const state = {
};

const getters = {
};

const actions = {
    GetRestoresStatuses({ commit }) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('import.get_restores_statuses');
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};